  document.addEventListener("DOMContentLoaded", function() {
      var lazyloadImages = document.querySelectorAll("img.lazy");
      var lazyloadThrottleTimeout;
      function lazyload() {
          if (lazyloadThrottleTimeout) {
              clearTimeout(lazyloadThrottleTimeout);
          }
          lazyloadThrottleTimeout = setTimeout(function() {
              var scrollTop = window.pageYOffset;
              lazyloadImages.forEach(function(img) {
                  if (img.offsetTop < (window.innerHeight + scrollTop)) {
                      img.src = img.dataset.src;
                      img.classList.remove('lazy');
                  }
              });
              if (lazyloadImages.length == 0) {
                  document.removeEventListener("scroll", lazyload);
                  window.removeEventListener("resize", lazyload);
                  window.removeEventListener("orientationChange", lazyload);
              }
          }, 20);
      }
      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
  });
  $(document).ready(function() {
      /*    var swiper = new Swiper(".cstm_slide-bestsellers", {
          slidesPerView: 1,
          grabCursor: true, 
          observer: true,
          spaceBetween: 30,
          observeParents: true,
          scrollbar: {
            el: ".cstmfe-bestsellers",
            hide: false,
            draggable: true,
            dragSize:600
          },
          navigation: {
            nextEl: '.swiper-button-next.argolf-bestsellers',
            prevEl: '.swiper-button-prev.argolf-bestsellers',
          }, 
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next.argolf-bestsellers',
            prevEl: '.swiper-button-prev.argolf-bestsellers',
          }
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          navigation: {
            nextEl: '.swiper-button-next.argolf-bestsellers',
            prevEl: '.swiper-button-prev.argolf-bestsellers',
          }
        },
        // when window width is >= 640px
        770: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 4
        }
      }   
        });*/
      var swiper = new Swiper(".cstm_slide", {
          slidesPerView: 1,
          grabCursor: true,
          observer: true,
          spaceBetween: 30,
          observeParents: true,
          scrollbar: {
              el: ".cstmfe",
              hide: false,
              draggable: true,
              dragSize: 600
          },
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
          breakpoints: {
              // when window width is >= 320px
              320: {
                  slidesPerView: 1,
                  navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                  }
              },
              // when window width is >= 480px
              480: {
                  slidesPerView: 2,
                  navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                  }
              },
              // when window width is >= 640px
              640: {
                  slidesPerView: 3
              },
              1024: {
                  slidesPerView: 4
              }
          }
      });
      // $(function(){
      //   $(window).scroll(function(){
      //     var winTop = $(window).scrollTop();

      //     // console.log(header_height);
      //     if(winTop >= 100){
      //       $('.site-nav__details').attr('open','');
      //       $('.site-nav__link').attr('aria-expanded','false');
      //     }else{
      //       $('.site-nav__details').attr('open');
      //       $('.site-nav__link').attr('aria-expanded','true');
      //     }//if-else
      //   });//win func.
      // });
      ////////////filter search
      $('.search_result').hide();
      $('.filter-search-close').hide();
      $("#myInput").on("keyup", function() {
          var value = $(this).val().toLowerCase();
          if (value != '') {
              // $('.search_result').show();
              $('.filter-search-close').show();
              $(".collapsible-content__inner .tag-list .tag.productType-search_result").filter(function() {
                  $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
              });
          } else {
              $('.collapsible-content__inner .tag-list .tag.productType-search_result').show();
              $('.filter-search-close').hide();
          }
      });
      $(document).on('click', '.filter-search-close', function(e) {
          e.preventDefault();
          $(this).hide();
          $(this).prev('input').val('');
          $('.collapsible-content__inner .tag-list .tag.productType-search_result').show();
          return false;
      });
    
      var search = $('.static-filter-btn');
      var close = $('#static-close');
      var overlay = $('.filter-backdrop');
      search.click(function() {
          filter_show();
      });
      close.click(function() {
          filter_hide();
      });

      function filter_show() {
          $('.collection_sidebar').addClass('filtered');
          $('html').addClass('js-drawer-open');
          overlay.show(20);
          close.show();
      }

      function filter_hide() {
          $('.collection_sidebar').removeClass('filtered');
          $('html').removeClass('js-drawer-open');
          overlay.hide();
          close.hide();
      }
      ////////////end fileter search

      ////////////Mega menu hover change image Start
      $(".site-nav__item .site-nav__details .megamenu__col .megamenu__col-title, .megamenu__col  .site-nav__dropdown-link").hover(function() {
          var img1 = $(this).find('.Menu_Img img:first-of-type').attr('src');
          var img2 = $(this).find('.Menu_Img img:nth-child(2)').attr('src');
          // alert(img1);
          $(".megamenu__wrapper .megamenu__promo.promo_image_1 img").attr("src", img1);
          $(".megamenu__wrapper .megamenu__promo.promo_image_1 img").attr("srcset", img1);

          $(".megamenu__wrapper .megamenu__promo.promo_image_2 img").attr("src", img2);
          $(".megamenu__wrapper .megamenu__promo.promo_image_2 img").attr("srcset", img2);
      });
      ////////////Mega menu hover change image End
  });
